import type { TourConfig } from '../types';

export const companiesPageTour: TourConfig = {
  pageId: 'companies',
  pageName: 'Referral Sources',
  portalId: 'crm',
  steps: [
    {
      element: '[data-tour="add-company"]',
      title: 'Add Company',
      intro:
        'Click here to add a new referral source company to the directory.',
      platform: 'both',
    },
    {
      element: '[data-tour="company-search"]',
      title: 'Search',
      intro:
        'Search by company name, email, or city to quickly find a referral source.',
      platform: 'both',
    },
    {
      element: '[data-tour="company-filters"]',
      title: 'Filter Controls',
      intro:
        'Filter companies by type, sales rep, visit status, temperature, and outreach status to narrow your view.',
      platform: 'both',
    },
    {
      element: '[data-tour="company-sort"]',
      title: 'Sort',
      intro:
        'Sort the list by name, visit status, or last visit date to prioritize your outreach.',
      platform: 'both',
    },
    {
      element: '[data-tour="company-cards"]',
      title: 'Company Cards',
      intro:
        'Each card shows the company name, contact info, visit status (traffic-light dot), temperature, and outreach status. Click a card to view details.',
      platform: 'both',
    },
    {
      element: '[data-tour="company-stats-footer"]',
      title: 'Visit Status Legend',
      intro:
        'The count shows how many companies match your current filters. Use "Clear filters" to reset.',
      platform: 'both',
    },
  ],
};
